import { Injectable } from '@angular/core';
import { VideoIntl } from '@knorr-bremse-portals/ngx-components/components/video';

@Injectable({providedIn: 'root'})
export class LocalVideoIntl extends VideoIntl {

  public override playButtonLabel = $localize `:video play button label@@8564202903947049539:Play`;
  public override pauseButtonLabel = $localize `:video pause button label@@9042260521669277115:Pause`;
  public override muteButtonLabel = $localize `:video mute button label@@2494293689061559568:Mute`;
  public override unmuteButtonLabel = $localize `:video unmute button label@@6453471031802119612:Unmute`;
  public override fullscreenButtonLabel = $localize `:video fullscreen button label@@4088802997354529592:Full screen`;
  public override endFullscreenButtonLabel = $localize `:video end fullscreen button label@@935797500101146847:Exit full screen`;
  public override videoTagUnsupported = $localize `:video video tag unsupported@@4037312571090214778:Your browser does not support the video tag`;
  public override seekSliderLabel = $localize `:video seek slider label@@4611498843799326065:Seek slider`;
  public override seekSliderTimeCombinator = $localize `:video seek slider time combinator@@5881876145178332550:of`;

}
